import { render, staticRenderFns } from "./EditDocumentSeriesModal.vue?vue&type=template&id=c3904d5c&"
import script from "./EditDocumentSeriesModal.vue?vue&type=script&lang=js&"
export * from "./EditDocumentSeriesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports